export const errors: Record<string, string> = {
    ERR_INVOICE_PDF_NOT_FOUND: "PDF fakture nije pronađen.",
    ERR_INVOICE_NOT_GENERATED: "Faktura nije generisana."
};